/**
 * Tlumaczenia AI powstaja po zapisie, poza requestem panelu — endpoint zapisu
 * odpowiada, zanim model cokolwiek zwroci. Encja niesie wiec status, a panel
 * odpytuje GET, dopoki stoi na `PENDING`.
 */
export type TranslationStatus = 'PENDING' | 'DONE' | 'FAILED';

export interface TranslationStatusSnapshot {
  translationStatus?: TranslationStatus | null;
  translationFailedLanguages?: string[] | null;
}

export interface TranslationWatchResult {
  status: TranslationStatus | null;
  failedLanguages: string[];
  // Czy zapis w ogole cokolwiek zaplanowal. Gdy komplet tlumaczen byl aktualny,
  // backend ustawia DONE od razu i nie ma o czym informowac uzytkownika.
  wasPending: boolean;
}

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Odpytuje `fetchStatus`, dopoki tlumaczenie trwa.
 *
 * Limit prob jest po to, zeby przy zgubionym evencie panel nie odpytywal w
 * nieskonczonosc — po jego wyczerpaniu zwracamy ostatni znany stan (`PENDING`),
 * a wolajacy decyduje, czy o tym powiedziec.
 */
export const watchTranslations = async (
  fetchStatus: () => Promise<TranslationStatusSnapshot>,
  { attempts = 20, delayMs = 1500 }: { attempts?: number; delayMs?: number } = {},
): Promise<TranslationWatchResult> => {
  let status: TranslationStatus | null = null;
  let failedLanguages: string[] = [];
  let wasPending = false;

  for (let attempt = 0; attempt < attempts; attempt += 1) {
    const snapshot = await fetchStatus();
    status = snapshot.translationStatus ?? null;
    failedLanguages = snapshot.translationFailedLanguages ?? [];

    if (status !== 'PENDING') break;

    wasPending = true;
    await wait(delayMs);
  }

  return { status, failedLanguages, wasPending };
};
